export const DOCUMENTATION_URL = "https://docs.swmansion.com/detour/docs/";
export const SWM_URL = "https://swmansion.com/";
export const DOCUMENTATION_URL_SDK =
  "https://docs.swmansion.com/detour/docs/SDK/sdk-installation";
export const SDK_FLUTTER_URL =
  "https://github.com/software-mansion-labs/detour-flutter-plugin";
export const SDK_IOS_URL =
  "https://github.com/software-mansion-labs/ios-detour";
export const SDK_ANDROID_URL =
  "https://github.com/software-mansion-labs/android-detour";
export const SDK_GITHUB_URL =
  "https://github.com/software-mansion-labs/react-native-detour";
export const FLUTTER_SDK_GITHUB_URL =
  "https://github.com/software-mansion-labs/detour-flutter-plugin";
export const IOS_SDK_GITHUB_URL =
  "https://github.com/software-mansion-labs/ios-detour";
export const ANDROID_SDK_GITHUB_URL =
  "https://github.com/software-mansion-labs/android-detour";
export const DOCUMENTATION_URL_UNIVERSAL_LINKS =
  "https://docs.swmansion.com/detour/docs/Fundamentals/universal-app-links-detour";
export const DOCUMENTATION_URL_EVENTS =
  "https://docs.swmansion.com/detour/docs/SDK/api-reference#detouranalytics";
export const DOCUMENTATION_URL_SMART_BANNERS =
  "https://docs.swmansion.com/detour/docs/Fundamentals/smart-banners";
export const DISCORD_INVITE_URL = "https://discord.gg/tj7uFuymne";
export const LANDING_PAGE_URL = "https://docs.swmansion.com/detour";
